import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import './Product.css';
import Rating from 'react-rating';

const Product = (props) => {
    console.log(props);
    const {name, img, seller, price, stock, star} = props.product;
    const element = <FontAwesomeIcon icon={faShoppingCart} />
    return (
        <div className="product">
            <div>
            <img src={img}  alt="" />
            </div>
           <div>
           <h4 className="product-name">{name}</h4>
            <p><small>by:{seller}</small></p>
            <p>Price:{price}</p>
            <p><small>only {stock} left in stock </small></p>
            <Rating 
            initialRating={star}
            emptySymbol="far fa-star icon-color"
            fullSymbol="fas fa-star icon-color" >
             </Rating>
            <br/>
            <button 
                onClick={ () => props.handleAddToCart(props.product)}
            className="purchas-bttn">
               {element}  add to cart</button>
           </div>
            
        </div>
    );
};

export default Product;